import styled from "styled-components";
import {LobbyHeaderDefaultButtonsBox} from "./lobby-header-button.default.box";

export const LobbyHeaderMrGreenButtonsBox = styled(LobbyHeaderDefaultButtonsBox)`
    border: 1px solid ${props => props.theme.colors.brandSecondaryLight};
    color: ${props => props.theme.colors.brandSecondaryLight};
    box-shadow: 0px 0px 3px #222223, 0px 0px 0px #222223, inset 0px 0px 10px rgba(255, 255, 255, 0.1), inset 0px 0px 1px #1F5331;
`;
